import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {DepotSelectListComponent} from "./components/depot-select-list/depot-select-list.component";
import {DepotSelectComponent} from "./components/depot-select/depot-select.component";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    DepotSelectComponent,
    DepotSelectListComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    ScrollingModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [],
  exports: [
    DepotSelectComponent,
    DepotSelectListComponent
  ]
})

export class DepotsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapDepotsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(DepotsModule);
};

export const downgradedDepotsModule = downgradeModule(bootstrapDepotsModule);
